var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import "./ColEditor.css";
const formItems = [{
  key: 'title',
  label: '标题'
}, {
  key: 'description',
  label: '描述'
}, {
  key: 'width',
  label: '宽度'
}];
let ColEditor = class ColEditor extends Vue {
  deleteColumn() {
    this.$emit('delete', this.index);
  }
  render() {
    const h = arguments[0];
    const col = this.value;
    const i = this.index;
    return h("div", {
      "class": "ucd-colEditor",
      "key": col.id
    }, [h("div", {
      "class": "ucd-colEditor-handle"
    }, [h("div", {
      "class": "ucd-colEditor-number"
    }, [i + 1])]), h("div", {
      "class": "ucd-colEditor-delete",
      "on": {
        "click": this.deleteColumn
      }
    }, [h("i", {
      "class": "fa fa-trash"
    })]), formItems.map(({
      key,
      label
    }) => h("div", {
      "class": "ucd-colEditor-formItem",
      "key": key
    }, [h("div", {
      "class": "ucd-colEditor-formLabel"
    }, [label]), h("div", {
      "class": "ucd-colEditor-formEditor"
    }, [h("input", {
      "domProps": {
        "value": col[key]
      },
      "attrs": {
        "type": "interopable-string"
      },
      "class": "uc-inputbox",
      "on": {
        "input": ev => {
          col[key] = ev.target.value;
          this.$emit('change');
        }
      }
    })])]))]);
  }
};
ColEditor = __decorate([Component({
  name: 'ColEditor',
  props: {
    value: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  }
  // events: delete(index), change()
})], ColEditor);
export default ColEditor;